import ClienteDirectoContext from "./ClienteDirectoContext";
import ClienteDirectoContextProvider from './ClienteDirectoContextProvider';

export default ClienteDirectoContext;

export * from './withClienteDirectoContext';
export {
    ClienteDirectoContextProvider,
};